import React, { useState } from "react";
import ProductsNavRow from "../rownavigator";

const PaintingDecoration = () => {
  // State management
  const [activeSubcategory, setActiveSubcategory] = useState(null);
  const [activeOption, setActiveOption] = useState(null);
  const [selectedProduct, setSelectedProduct] = useState(null);
  const [isModalOpen, setIsModalOpen] = useState(false);

  // Data structure
  const tools_equipments = {
    name: "Tools & Equipments",
    subcategories: {
      hand_tools: {
        name: "Hand Tools",
        options: {
          hammers_axes: {
            name: "Hammers, Crowbars & Axes",
            images: [""],
            products: []
          },
          screwdrivers: {
            name: "Screwdrivers",
            images: [""],
            products: []
          },
          chisels: {
            name: "Chisels",
            images: [""],
            products: []
          },
          wire_brushes: {
            name: "Wire Brushes",
            images: [""],
            products: []
          },
          breakers_demolition: {
            name: "Breakers & Demolition Tools",
            images: [""],
            products: []
          },
          tape_measure: {
            name: "Tape Measure",
            images: [""],
            products: []
          },
          bricklaying: {
            name: "Bricklaying Tools",
            images: [""],
            products: []
          },
          nail_guns: {
            name: "Nail Guns",
            images: [""],
            products: []
          },
          vice_clamp: {
            name: "Vice & Clamp",
            images: [""],
            products: []
          },
          hand_saws: {
            name: "Hand Saws",
            images: [""],
            products: []
          },
          hex_keys: {
            name: "Hex Keys",
            images: [""],
            products: []
          },
          electrical_tester: {
            name: "Electrical Tester",
            images: [""],
            products: []
          },
          soldering_iron: {
            name: "Soldering Iron",
            images: [""],
            products: []
          },
          blow_torches: {
            name: "Blow Torches",
            images: [""],
            products: []
          }
        }
      },

      equipments: {
        name: "Equipments",
        options: {
          brackets: { name: "Brackets", images: [""], products: [] },
          nails: { name: "Nails", images: [""], products: [] },
          sandpaper: { name: "Sandpaper", images: [""], products: [] },
          workshop_machinery: { name: "Workshop Machinery", images: [""], products: [] },
          sawing_blades: { name: "Sawing & Blades Drill Accessories", images: [""], products: [] },
          hole_saws: { name: "Hole Saws", images: [""], products: [] },
          ladders_steps: { name: "Ladders & Steps", images: [""], products: [] },
          step_ladders: { name: "Step Ladders", images: [""], products: [] },
          step_stools: { name: "Step Stools & Step-Up Ladders", images: [""], products: [] },
          work_platforms: { name: "Work Platforms", images: [""], products: [] }
        }
      },

      power_tools: {
        name: "Power Tools",
        options: {
          drills: {
            name: "Drills",
            options: {
              combi: { name: "Drill Drivers", images: ["/assets/drills/drilldrivers.jpg"], products: [] },
              hammer: { name: "Hammer Drills", images: ["/assets/drills/hammerdrills.jpg"], products: [] },
              sds: { name: "Magnetic Drill Presss", images: ["/assets/drills/magneticdrill.jpg"], products: [] },
              angle: { name: "Mixers", images: ["/assets/drills/mixersdrill.jpg"], products: [] },
              specialitydrill: { name: "Specialty Drills", images: ["/assets/drills/specialitydrill.jpg"], products: [] }
            }
          },
          saws: {
            name: "Saws",
            options: {
              bandSaw: { name: "Band Saw", images: ["/assets/saw/bandsaw.jpg"], products: [] },
              chopSaw: { name: "Chop Saw", images: ["/assets/saw/chopsaw.jpg"], products: [] },
              circularSaw: { name: "Circular Saw", images: ["/assets/saw/circularsaw.jpg"], products: [] },
              jigSaw: { name: "Jigsaw", images: ["/assets/saw/jigsaw.jpg"], products: [] },
              misterSaw: { name: "Mister Saw", images: ["/assets/saw/mitersaw.jpg"], products: [] },
              multimaterialSaw: { name: "Multimaterial Saw", images: ["/assets/saw/multimaterialsaw.jpg"], products: [] },
              reciprocatingSaw: { name: "Reciprocating Saw", images: ["/assets/saw/reciprocatingsaw.jpg"], products: [] },
              scrollSaw: { name: "Scroll Saw", images: ["/assets/saw/scrollsaw.jpg"], products: [] },
              tablesaw: { name: "Table Saw", images: ["/assets/saw/tablesaw.jpg"], products: [] },
              tilemasonarysaw: { name: "Tile & Mason", images: ["/assets/saw/tilemasonarysaw.jpg"], products: [] },
              tracksaw: { name: "Track Saw", images: ["/assets/saw/tracksaw.jpg"], products: [] }
            }
          }
        }
      },

      power_tools_accessories: {
        name: "Power Tools Accessories",
        options: {
          drilling_sets: { name: "Drilling Sets", images: [""], products: [] },
          drilling_bits: { name: "Drilling Bits", images: [""], products: [] },
          screwdriver_bits: { name: "Screwdriver Bits", images: [""], products: [] },
          power_accessories: { name: "Power & Accessories", images: [""], products: [] },
          jigsaw_blades: { name: "Jigsaw Blade", images: [""], products: [] },
          wood_drill_bits: { name: "Wood Drill Bits", images: [""], products: [] },
          specialist_bits: { name: "Specialist Drill Bits & Accessories", images: [""], products: [] },
          core_drill_bits: { name: "Core Drill Bits", images: [""], products: [] }
        }
      },

      tiling_tools: {
        name: "Tiling Tools & Accessories",
        options: {
          spacer: { name: "Tile Spacer", images: [""], products: [] },
          cutter: { name: "Tile Cutter", images: [""], products: [] },
          tiling_tools: { name: "Tiling Tools", images: [""], products: [] }
        }
      },

      measure_level_tools: {
        name: "Measure & Level Tools",
        options: {
          tape_measure: { name: "Tape Measure", images: [""], products: [] },
          spirit_levels: { name: "Spirit Levels", images: [""], products: [] },
          laser_levels: { name: "Laser Levels", images: [""], products: [] },
          measure_level: { name: "Measure Level Tools", images: [""], products: [] }
        }
      }
    }
  };


  // Handlers
  const handleSubcategoryClick = (subcategoryKey) => {
    setActiveSubcategory(subcategoryKey);
    setActiveOption(null);
  };

  const handleOptionClick = (optionKey) => {
    setActiveOption(optionKey);
  };

  const handleProductClick = (product) => {
    setSelectedProduct(product);
    setIsModalOpen(true);
  };

  const closeModal = () => {
    setIsModalOpen(false);
    setSelectedProduct(null);
  };

  // Render subcategories
  const renderSubcategories = () => {
    if (!tools_equipments?.subcategories) return null;

    return (
      <div className="mb-3">
        <h2 className="text-lg font-semibold mb-3">Subcategories</h2>
        <div className="flex flex-wrap gap-2">
          {Object.entries(tools_equipments.subcategories).map(
            ([key, subcategory]) => (
              <button
                key={key}
                className={`px-3 py-1 rounded-full text-sm ${activeSubcategory === key
                  ? "bg-blue-500 text-white"
                  : "bg-gray-200 text-gray-700 hover:bg-gray-300"
                  }`}
                onClick={() => handleSubcategoryClick(key)}
              >
                {subcategory?.name ?? "Unnamed Subcategory"}
              </button>
            )
          )}
        </div>
      </div>
    );
  };

  // Render options
  const renderOptions = () => {
    if (!activeSubcategory) return null;

    const subcategory =
      tools_equipments?.subcategories?.[activeSubcategory];
    if (!subcategory?.options) return null;

    return (
      <div className="mb-3">
        <h2 className="text-lg font-semibold mb-3">Options</h2>
        <div className="flex flex-wrap gap-2">
          {Object.entries(subcategory.options).map(([key, option]) => (
            <button
              key={key}
              className={`px-3 py-1 rounded-full text-sm ${activeOption === key
                ? "bg-blue-500 text-white"
                : "bg-gray-200 text-gray-700 hover:bg-gray-300"
                }`}
              onClick={() => handleOptionClick(key)}
            >
              {option?.name ?? "Unnamed Option"}
            </button>
          ))}
        </div>
      </div>
    );
  };

  // Render products
  const renderProducts = () => {
    let products = [];

    if (activeSubcategory && activeOption) {
      const option =
        tools_equipments?.subcategories?.[activeSubcategory]?.options?.[
        activeOption
        ];
      if (option?.products) {
        products = option.products;
      } else if (option?.options) {
        const nestedOptionKey = Object.keys(option.options)[0];
        products = option?.options?.[nestedOptionKey]?.products ?? [];
      }
    } else if (
      activeSubcategory &&
      tools_equipments?.subcategories?.[activeSubcategory]?.products
    ) {
      products =
        tools_equipments?.subcategories?.[activeSubcategory]?.products ?? [];
    }

    if (!products || products.length === 0) {
      return (
        <div className="text-center py-10">
          <p className="text-gray-500">
            Select a subcategory and option to view products
          </p>
        </div>
      );
    }

    return (
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
        {products.map((product, index) => (
          <div
            key={index}
            className="border rounded-lg overflow-hidden shadow-md hover:shadow-lg transition-shadow cursor-pointer"
            onClick={() => handleProductClick(product)}
          >
            <div className="h-48 bg-gray-200 overflow-hidden">
              <img
                src={product?.image ?? "/placeholder.png"}
                alt={product?.name ?? "Unnamed Product"}
                className="w-full h-full object-cover"
              />
            </div>
            <div className="p-4">
              <h3 className="font-semibold text-lg mb-2">
                {product?.name ?? "Unnamed Product"}
              </h3>
              <p className="text-gray-600 mb-2">
                {product?.use ?? "No use info"}
              </p>
              {/* <p className="text-blue-600 font-bold">
                {product?.price || "Price not available"}
              </p> */}
            </div>
          </div>
        ))}
      </div>
    );
  };

  // Modal
  const renderProductModal = () => {
    if (!isModalOpen || !selectedProduct) return null;

    return (
      <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center p-4 z-50">
        <div className="bg-white rounded-lg max-w-2xl w-full max-h-[90vh] overflow-y-auto">
          <div className="p-6">
            <div className="flex justify-between items-center mb-4">
              <h2 className="text-2xl font-bold">
                {selectedProduct?.name ?? "Unnamed Product"}
              </h2>
              <button
                onClick={closeModal}
                className="text-gray-500 hover:text-gray-700"
              >
                ✖
              </button>
            </div>

            <div className="mb-4">
              <img
                src={selectedProduct?.image ?? "/placeholder.png"}
                alt={selectedProduct?.name ?? "Unnamed Product"}
                className="w-full h-64 object-cover rounded"
              />
            </div>

            <div className="space-y-3">
              <div>
                <h3 className="font-semibold">Uses:</h3>
                <p>{selectedProduct?.use ?? "N/A"}</p>
              </div>

              <div>
                <h3 className="font-semibold">Details:</h3>
                <p>{selectedProduct?.details ?? "N/A"}</p>
              </div>

              {/* <div>

                <p className="text-blue-600 font-bold">
                  {selectedProduct?.price || "Price not available"}
                </p>
              </div> */}
            </div>

            <div className="mt-6 flex justify-end">
              <button
                onClick={closeModal}
                className="px-4 py-2 bg-blue-500 text-white rounded hover:bg-blue-600"
              >
                Close
              </button>
            </div>
          </div>
        </div>
      </div>
    );
  };

  return (
    <>
      <ProductsNavRow />
      <div className="container mx-auto px-4 py-2">
        <h1 className="text-3xl font-bold mb-3">
          {tools_equipments.name} Products
        </h1>

        {renderSubcategories()}
        {renderOptions()}
        {renderProducts()}
        {renderProductModal()}
      </div>
    </>
  );
};

export default PaintingDecoration;
